import zipWith from 'lodash/zipWith';
import prop from 'lodash/property';
import values from 'lodash/values';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFilteredParametersValuesNotEmpty } from 'store/dataset';

import { computeValuesProps } from '../../../../calculators/dataset/rawTable';

import SummaryTable from './SummaryTable';

class MixedContainer extends React.PureComponent {
  static propTypes = {
    firstParsedParameterValues: PropTypes.array.isRequired,
    secondParsedParameterValues: PropTypes.array.isRequired,

    numericalParameter: PropTypes.string.isRequired,
    categoricalParameter: PropTypes.string.isRequired
  };

  get levelsProps () {
    const {
      firstParsedParameterValues,
      secondParsedParameterValues,

      numericalParameter,
      categoricalParameter
    } = this.props;

    const filteredDataset = zipWith(
      firstParsedParameterValues,
      secondParsedParameterValues,
      (category, value) => ({
        [categoricalParameter]: category,
        [numericalParameter]: value
      })
    );
    const numericalGroupedByCategorical = mapValues(
      groupBy(filteredDataset, categoricalParameter),
      (datasetChunk, levelName) => ({
        name: levelName,
        numericalParameter,
        ...computeValuesProps(datasetChunk.map(prop(numericalParameter)))
      })
    );

    return values(numericalGroupedByCategorical);
  }

  get categoricalParameter () {
    return this.props.categoricalParameter;
  }

  get numericalParameter () {
    return this.props.numericalParameter;
  }

  render () {
    return (
      <SummaryTable
        levelsProps={this.levelsProps}
        categoricalParameter={this.categoricalParameter}
        numericalParameter={this.numericalParameter}
      />
    );
  }
}

const mapStateToProps = (
  state,
  { numericalParameter, categoricalParameter }
) => (getFilteredParametersValuesNotEmpty(
  state,
  categoricalParameter,
  numericalParameter
)
);

export default connect(mapStateToProps)(MixedContainer);
